// extracted by mini-css-extract-plugin
export default {"info-window":"ABA76A"};